export enum TabStyleType {
  Filled = `filled`,
  Outline = `outline`,
}
